/* @flow */

import api from '../utils/api';
import getHorariosPorDiaSemana from './get-horarios-por-dia-semana';
import viewFormularioFuncionamento from './view-formulario-funcionamento';
import modalHabilitarTodosFuncionamentos from './modal-habilitar-todos-funcionamentos';

const getHorarios = () => api
    .getFuncionamento()
    .then(response => response.data)
    .then(getHorariosPorDiaSemana);

const getCheckbox = () => Array.from(document.querySelectorAll('input[name="funcionamentosId[]"]'));

const getIdsSelecionados = () => getCheckbox()
    .filter(el => el instanceof HTMLInputElement && el.checked)
    .map(el => el instanceof HTMLInputElement && el.value);

const desabilitarUltimoHorarioMostraModalHabilitar = (e: Event) => {
    if (getIdsSelecionados().length > 0) {
        return;
    }

    if (e.target instanceof HTMLInputElement) {
        modalHabilitarTodosFuncionamentos(e.target);
    }
};

const renderFormularioFuncionamento = async (container: HTMLElement) => {
    const horarios = await getHorarios();
    container.innerHTML = viewFormularioFuncionamento(horarios);

    getCheckbox().forEach((el) => {
        el.onchange = desabilitarUltimoHorarioMostraModalHabilitar;
    });
};

export default renderFormularioFuncionamento;
